module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "pagination pagination-sm"
  }, [_c('li', {
    class: {
      'disabled': _vm.page === 1
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.go(_vm.page - 1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })])]), _vm._v(" "), _vm._l((_vm.pages), function(p) {
    return _c('li', {
      class: {
        'active': _vm.page === p
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.go(p)
        }
      }
    }, [_vm._v(_vm._s(p))])])
  }), _vm._v(" "), _c('li', {
    class: {
      'disabled': _vm.page === _vm.pages.length
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.go(_vm.page + 1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  })])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d4c06260"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/page-thingy.vue
// module id = 829
// module chunks = 3